export default __webpack_public_path__ + "static/media/ttac2.9e82d3a7.svg";